<template>
    <div id="rechargeB">
		<div class="header">
			<div class="logo">
                <img v-if="shebeiLogin==1" src="./../../assets/shebei.jpg" alt=""/>
				<img v-else-if="simInfo.flowRatePool=='联通'||simInfo.flowRatePool=='乐语'" src="./../../assets/cucc.png" alt="">
				<img v-else-if="simInfo.flowRatePool=='电信'" src="./../../assets/ctcc.png" alt="">
				<img v-else-if="simInfo.flowRatePool=='移动'||simInfo.flowRatePool=='移动接口'" src="./../../assets/cmcc.png" alt="">
				<img v-else :src="wxHeadImg" alt="微信头像">
			</div>
			<div class="header-userInfo">
				<div class="iccid-line">{{ this.$store.state.recordLoginText }}	</div>
				<div class="el-status card-bg">在用套餐：{{simInfo.pkgName?simInfo.pkgName:'暂无套餐'}}</div>
			</div>
		</div>
        <div class="packagePanel">
            <div class="tabbar">
                <p :class="{'activeTab':tabbar==1}" @click="tabbarClick('1')">
					<span>基础套餐</span>
				</p>
                <p :class="{'activeTab':tabbar==2}" @click="tabbarClick('2')">
					<span v-if="shebeiLogin!=1">加油套餐</span>
                    <span v-else>体验包</span>
				</p>
            </div>
			<van-row>
			  <van-col span="24" class="package" v-for="item in simData" :key="item.id" @click="changeState(item,'1')" v-show="tabbar==1">
				<div class="package-name" :class="{'overlay-package':item.type == 11, 'label-defined-active':indexActive==item.id}"> 
					<!-- <h1 style="color: #07c160;" v-if="item.type == 11 ">{{item.packageName}}</h1> -->
                    <div class="titleRemark" v-if="item.titleRemark ">{{ item.titleRemark }}</div>
                    <div class="price-title" :style="{'padding-top' : item.titleRemark ? '10px' : ''}">
                        <h1>{{item.packageName}}</h1>
                        <p>{{item.remark}}</p>
                        <p style="color:red;">{{item.redRemark}}</p>
                        <p style="color:#bfae19;;font-weight :bold;text-align: center;font-size: 16px;">{{item.dayRemark}}</p>
                            <p>{{item.dayRemarkInfo}}</p>
                    </div>
                    <div class="dialog" v-if="item.limitState === 1">
                        <div class="deblocking"  @click="clickDeblock(item.limitRemark)">点击解锁</div>
                    </div>
                     <!-- <p style="color:red">{{item.remarkPrice}}</p> -->
					<!-- <p v-if="item.type==11" style="color: #07c160;">
						有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>
					<p v-else-if="(item.type==2 || item.type == 10 ) && isNextMonth=='1'">
						有效期：{{firstDayOfNextMonth()}} 至 {{lastDayOfNextMonth()}}</p>
					<p v-else-if="(item.type==2 || item.type == 10 ) && isNextMonth=='0'">
						有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>
					 <p v-else-if="item.type==12">
						有效期：根据套餐结束时间叠加
					</p>
					  <p v-else-if="item.type==13">
						有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}
					</p>
					 <p v-else-if="item.type==14||  item.type == 15|| item.type == 17">
						有效期： 每个月26号为一个核算周期
					</p>
					<p v-else-if="item.type!=2 && item.type!=4 && item.type!=3">
						有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{afterManyDays(item.type==7?90:item.type==8?180:item.type==9?365:30)}}
					</p>
					<p v-if="item.type==12 ||item.type==6">月底不清0，套餐30天有效期，30天之内只能生效一次基础套餐，用完请订购加速包。</p>
					<p v-if="item.type==13">月底清0，基础套餐用完请购买加速包。</p>
                    <p v-if="item.type==2">基础套餐可无限叠加。</p> -->
					<p class="package-price">￥{{item.salePriceRmb - ( toatl ? toatl:0) }}元</p>
				</div>
				</van-col>
				<van-col span="24" class="package" v-for="item in simData2" :key="item.id" @click="changeState(item, 2)" v-show="tabbar==2">
					<!-- <span class="label-defined" :class="{'label-defined-active':indexActive2==item.id}">
						<label><van-icon name="success" color="#fff"/></label>
					</span> -->

					<div class="package-name" :class="{'label-defined-active':indexActive2==item.id}"> 
						<!-- <h1 style="color: #07c160;" v-if="item.type == 11 || item.type == 13 || item.type == 18|| item.type == 16||item.type == 19">{{item.packageName}}</h1> -->
                         <div class="titleRemark" v-if="item.titleRemark ">{{ item.titleRemark }}</div>
                         <div class="price-title" :style="{'padding-top' : item.titleRemark ? '10px' : ''}">
                            <h1>{{item.packageName}}</h1>
                            <p>{{item.remark}}</p>
                            <p style="color:red;">{{item.redRemark}}</p>
                            <p style="color:#bfae19;;font-weight :bold;text-align: center;font-size: 16px;">{{item.dayRemark}}</p>
                            <p>{{item.dayRemarkInfo}}</p>
                        </div>
                        <div class="dialog" v-if="item.limitState === 1">
                            <div class="deblocking"  @click="clickDeblock(item.limitRemark)">点击解锁</div>
                        </div>
                           <!-- <p style="color:red">{{item.remarkPrice}}</p> -->
						<!-- <p v-if="item.type==11">
							有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{lastDayOfThisMonth()}}</p>
                        <p v-else >主套餐时间内无限叠加，加油包随基础套餐时间清零</p> -->
					
						<p class="package-price">￥{{item.salePriceRmb}}元</p>
					</div>
				</van-col>
			</van-row>
        </div>
        <Checkstand 
            :checkstandStyle="checkstandStyle"
            :dataToPay="dataToPay"
            :price="price" 
            :yuPrice="yuPrice"
            :yr="yr"
            :typeStyle="typeStyle"/>
        
        <div class="toRecharge">
            <div class="quan" v-if="showjuan">
                <div class="w-zh">活动余额</div>
                <div class="z-icon" @click="lintTo"><span v-if="toatl">-￥{{ toatl }}</span></div>
            </div>
            <!-- <div class="quan" v-else>
                <div class="w-zh">优惠券</div>
                <div class="z-icon" @click="(nu = 1)">暂无可用优惠卷</div>
            </div> -->
             <p class="detail" v-if="isNaturalMonth && thisCucc==1" style="color: #FF6463;">每月22号后 请优先选择次月生效
                <!-- <span v-show='this.isNextMonth==0'>，<span style="color: #FF6463;">本月26号清零。</span></span>
                <span v-show='this.isNextMonth==1'>，<span style="color: #FF6463;">次月26号清零。</span></span> -->
            </p>
			<p class="detail" v-else-if="isNaturalMonth && isShowdetail">每月25号后 请优先选择次月生效
			    <!-- <span v-show='this.isNextMonth==0'>，月底清零。</span>
			    <span v-show='this.isNextMonth==1'>，次月月底清零。</span> -->
			</p>
            <div class="toRecharge-top" v-if="showMonthChoose || isNaturalMonth">
                <van-radio-group v-model="isNextMonth" class="radio-group-defined">
                    <div>
                        <van-radio name="0" checked-color="#FF6463">本月生效</van-radio>
                    </div>
                    <div>
                        <van-radio name="1" checked-color="#FF6463">次月生效</van-radio>
                    </div>
                </van-radio-group>
            </div>
            <!-- <div class="toRecharge-bottom">
                <p>合计：<span>{{money_format(price, 2, '.', ',')}} 元</span></p>
                <div class="toRechargeBtn" @click="toRecharge()">订 购</div>
            </div> -->
            
            <div class="toRecharge-bottom" v-if="showjuan">
                <p>合计：<span>{{ money_format(price, 2, '.', ',') - toatl > 0 ? money_format( money_format(price, 2, '.', ',') * 1 - toatl) : 0 }}
                    元</span><span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;">优惠
                    ¥{{ toatl }}</span></p>
                <div class="toRechargeBtn" @click="toRechange()" v-if="limitState!==1">
                    <div class="n-btn">订 购</div>
                </div>
                <div class="toRechargeBtn toRechargeBtn1" v-else>
                    <div class="n-btn">订 购</div>
                </div>
            </div>
            <div class="toRecharge-bottom" v-else>
                <p>合计：<span>{{ money_format(price, 2, '.', ',') - 0 > 0 ? money_format(price, 2, '.', ',') - 0 : 0 }}
                    元</span><span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;">优惠 ¥ 0</span></p>
                <div class="toRechargeBtn" @click="toRechange()" v-if="limitState !==1">
                    <div class="n-btn">订 购</div>
                </div>
                <div class="toRechargeBtn toRechargeBtn1" v-else>
                    <div class="n-btn">订 购</div>
                </div>
            </div>

        </div>
        <van-dialog
            v-model="helpShow"
            title="点击解锁"
            :show-confirm-button="false"
            >
            <div class="dialog-text">{{ limitRemark }}</div>
            <div class="btn-vis">
                <van-button type="primary"  class="dialog-btn2" @click="closrDialog">取消</van-button>
                <van-button type="primary"  class="dialog-btn3" @click="toBalanceRecharge">购买余额</van-button>
            </div>
            </van-dialog>
    </div>
</template>
<script>
import { wxRequest} from '@/api/user.js'
import { Dialog } from 'vant';
import Checkstand from "@/components/Checkstand";
export default {
    components: {Checkstand},
    data(){
        return {
            shebeiLogin: localStorage.getItem("shebeiLogin"),
            indexActive: '',
            showjuan: true,//是否展示优惠卷
            toatl: 0,
            simData: [],
			simInfo:{},
            nu:0,
            itemInfo: {
                supplierTypeName: localStorage.getItem('supplierTypeName'),
                flowRate: '',
                salePriceRmb: ''
            },
            secondaryId: '',
            primaryId: '',
            isAdmin: '',
            globalIsAdmin: '',
			wxHeadImg: localStorage.getItem('wxHeadImg'),
            isNextMonth: '0',
            payType: 1,
            isNaturalMonth: false,
            showCheckstand: false,
            showMonthChoose: false,//判断是否显示本月次月

            //收银台
            checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },
            dataToPay: {},
            price:0,
            typeStyle: 1, //流量充值入口为1
            tabbar: 1,

            simData2: [],
            indexActive2: '',
            itemInfo2: {
                supplierTypeName: '',
                flowRate: '',
                salePriceRmb: ''
            },
            result:{},
            helpShow:false,
            isShowdetail:false,
            thisCucc:0,
            yr:0,
            yuPrice:false,
            amountObj:{},
            limitRemark:'',
            limitState:''
        }
    },
    mounted(){
        wxRequest("sim/get/amount", {iccid: this.$store.state.iccid,}, "post").then(res=>{
            this.amountObj = res.data
        })
    },
    methods: {
        // changeState(item){            
        //     this.indexActive = item.id;
        //     this.itemInfo = item; 
        //     this.price = item.salePriceRmb;

        //     if(item.isAdmin!=null&&
        //         item.isAdmin!=undefined&&
        //         item.isAdmin==1){
        //         this.isAdmin = item.isAdmin;
        //     }else{
        //         this.isAdmin = this.globalIsAdmin;
        //     }

        //     this.isNaturalMonth = item.type == 2 || item.type == 10? true : false; 
        //     this.showMonthChoose = item.type == 2 ? true : false; 
        // },
        clickDeblock(data){
            this.limitRemark = data
            this.helpShow = true
        },
        closrDialog(){
            this.helpShow = false
        },
        toBalanceRecharge() {
            let fd = new FormData();
            fd.append("supplierId", sessionStorage.getItem("supplierCode"));
            wxRequest("sim/invent/state", fd, "post").then((res) => {
                if (res.data.code == 200) {
                    this.$router.push({
                        path: "/user/balanceRecharge",
                        query: {
                        iccid: this.$store.state.iccid,
                        },
                    });
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            });
        },
        lintTo() {
            this.$router.push({ name: 'coupon' })
        },
        changeState(item, tabbar){
            this.limitState = item.limitState
            if(tabbar == 1){
                this.indexActive = item.id;
                this.itemInfo = item; 
                this.price = item.salePriceRmb;
            }else {
                this.indexActive2 = item.id;
                this.itemInfo2 = item; 
                this.price = item.salePriceRmb;
            }
            if(item.isAdmin!=null && item.isAdmin!=undefined && item.isAdmin==1){
                this.isAdmin = item.isAdmin;
            }else{
                this.isAdmin = this.globalIsAdmin;
            }
            this.isNaturalMonth = item.type == 2 || item.type == 10 || item.type==14||item.type==6|| item.type==17|| item.type==25? true : false; 
            this.showMonthChoose = item.type == 2 || item.type == 10 || item.type==14||item.type==6|| item.type==17|| item.type==25? true : false; 
            this.isShowdetail= item.type == 2 || item.type == 10? true : false; 
            

        },

        toRechange(){
            this.showCheckstand=false;
            var iccids=localStorage.getItem('iccid');
            let _data = { iccid: iccids};
            let self = this;
            var pop = {                
                iccid: this.$store.state.iccid,
                pkgId: this.itemInfo.id,
                isAdmin: this.isAdmin,
                isNextMonth: this.isNextMonth
            }
              //判断是否是月卡
            if(this.isNaturalMonth||this.showMonthChoose==true){
                pop.isNextMonth = this.isNextMonth;
            }else{
                pop.isNextMonth = '0';//万能卡
            }
            if(this.tabbar == 1){
                pop.pkgId=this.itemInfo.id
            }else{
                pop.pkgId=this.itemInfo2.id
            }
            wxRequest("sim/activity/timer",pop, "post").then(res => {
                var result=res.data.data;
                var data = {                
                    iccid: this.$store.state.iccid,
                    soldPackageId: this.itemInfo.id,
                    isAdmin: this.isAdmin,
                    secondaryId: this.secondaryId,
                    primaryId: this.primaryId,
                    toatl: this.toatl,
                    salePriceRmb: this.itemInfo.salePriceRmb - this.toatl * 1 > 0 ? this.money_format(this.itemInfo.salePriceRmb - this.toatl * 1 ,2, '.', ','): 0,
                    mobile: this.mobile
                }
                
                let data2 = {                
                    iccid: this.$store.state.iccid,
                    soldPackageId: this.itemInfo2.id,
                    isAdmin: this.isAdmin,
                    secondaryId: this.secondaryId,
                    primaryId: this.primaryId,
                    toatl: this.toatl,
                    salePriceRmb: this.itemInfo2.salePriceRmb - this.toatl * 1 > 0 ? this.money_format(this.itemInfo2.salePriceRmb - this.toatl * 1 ,2, '.', ','): 0,
                    mobile: this.mobile
                }
                if(res.data.code == 200){
                    Dialog.confirm({
                        title: "套餐生效提醒",
                        message: "生效时间："+res.data.data.start  +"<br/>到期时间："+res.data.data.end+"<br/>谨慎订购，误订不退款"
                    }) .then(() => {
                        //判断是否是月卡
                        if(this.isNaturalMonth){
                            data.isNextMonth = this.isNextMonth;
                        }else{
                            data.isNextMonth = '0';//万能卡
                        }

                        if(this.$store.state.source != false){
                            data.source = this.$store.state.source;
                        }else{
                            data.source = 'xxgzh';
                        }

                        this.$store.state.showCheckstand = true;
                        this.$store.state.showCheckstandSource = 'flowRecharge';
                        if(this.tabbar == 1){
                            this.dataToPay = data;
                        }else {
                            this.dataToPay = data2;
                        }
                    }).catch(() => {});
                }else{
                    //判断是否是月卡
                    if(this.isNaturalMonth){
                        data.isNextMonth = this.isNextMonth;
                    }else{
                        data.isNextMonth = '0';//万能卡
                    }

                    if(this.$store.state.source != false){
                        data.source = this.$store.state.source;
                    }else{
                        data.source = 'xxgzh';
                    }

                    this.$store.state.showCheckstand = true;
                    this.$store.state.showCheckstandSource = 'flowRecharge';
                    if(this.tabbar == 1){
                        this.dataToPay = data;
                    }else {
                        this.dataToPay = data2;
                    }
                }
                var zPrice= 0
                if(this.tabbar == 1){
                    zPrice= this.money_format(this.price, 2, ".", ",") - data.toatl > 0 ? this.money_format(this.money_format(this.price, 2, ".", ",") - data.toatl) : 0
                }else {
                    zPrice= this.money_format(this.price, 2, ".", ",") - data2.toatl > 0 ? this.money_format(this.money_format(this.price, 2, ".", ",") - data2.toatl) : 0
                }
                if(this.amountObj.code === '200'){
                    this.yr = this.amountObj.data
                    if(this.amountObj.data < zPrice * 1){
                        this.yuPrice = false
                    }else{
                        this.yuPrice = true
                    }
                }else{
                    this.yuPrice = true
                }
            })
        },

        //第n天后
        afterManyDays(manyDays){
            let startTime = new Date();
            let startDate = new Date(startTime);
            startDate.setDate(startDate.getDate() + manyDays);
            return this.dateFormat('yyyy-MM-dd', startDate);
        },

        // 本月最后一天
        lastDayOfThisMonth(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 1, 0));
        },

        //下个月第一天
        firstDayOfNextMonth(){
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();

            let date2 = new Date(year, month + 1, 1)
            return this.dateFormat('yyyy-MM-dd', new Date(date2));
        },
        // 下个月最后一天
        lastDayOfNextMonth(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth();
            return this.dateFormat('yyyy-MM-dd', new Date(year, month + 2, 0));
        },

        changePayType(type){
            this.payType = type;
        },

        //点击tabbar
        tabbarClick(index){
            this.tabbar = index;
            this.showjuan = !this.showjuan
            if(this.simData.length != 0 && index == '1'){
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                this.itemInfo = this.simData[0];
                if (this.$route.query.total) {
                    this.toatl = this.$route.query.total * 1 || 0
                    this.secondaryId = this.$route.query.secondaryId
                    this.primaryId = this.$route.query.primaryId
                }else{
                    console.log(this.result)
                    this.toatl = this.result.subJuan.price * 1 || 0
                    if(this.result.subJuan.types === 1){
                        this.secondaryId = this.result.subJuan.id
                    }else{
                        this.primaryId = this.result.subJuan.id
                    }
                }
				this.changeState(this.itemInfo,index)
            }else if(this.simData2.length != 0 && index == '2'){
                this.indexActive2 = this.simData2[0].id;
                this.price = this.simData2[0].salePriceRmb;
                this.itemInfo2 = this.simData2[0];
                this.toatl = 0
                this.secondaryId = ''
                this.primaryId = ''
				this.changeState(this.itemInfo2,index)
            }
        }
    },
    created(){
		wxRequest("sim/detail", { iccid: this.$store.state.iccid	}, "post").then(res => {
			if (res.data.code == 200) {
				this.simInfo =  res.data.data;
			}
		})
        var data = {
            iccid: this.$store.state.iccid
        }
        wxRequest("sim/user/soldPkg/next/pkg", data, "get").then(res => {
            var result = res.data.data;
            if(res.data.code == 200){
                Dialog.alert({
                    title: '温馨提示',
                    message:res.data.message
                })
            }
        })
        wxRequest("sim/user/soldPkg", data, "get").then(res => {
            var result = res.data.data;
            this.result = res.data.data;
            if(res.data.code == 200 && result.list.length > 0){
                this.endTime = result.endTime;
                let resultArray1 = [];
                let resultArray2 = [];
                for(let i=0; i<result.list.length; i++){
                     console.log('当前type'+result.list[i].type);
                    if(result.list[i].type == 17||result.list[i].type == 14){
                        this.thisCucc=1
                    }

                    // if(result.list[i].type == 11 || result.list[i].type == 13){
                    //     resultArray1.push(result.list[i]);
                    // }else if(result.list[i].type == 7 || result.list[i].type == 8 || result.list[i].type == 9){
                    //     resultArray2.unshift(result.list[i]);
                    // }else {
                    //     resultArray1.unshift(result.list[i]);
                    // }
                    if(result.list[i].type == 1 || result.list[i].type == 4  || result.list[i].type == 5 || result.list[i].type == 11 || result.list[i].type == 13 || result.list[i].type == 16 ||result.list[i].type == 18 ||result.list[i].type == 19){
                        this.simData2.push(result.list[i])
                        this.simData2.sort((a,b) => b.sort - a.sort)
                    }else {
                        if(result.list[i].type == 7 || result.list[i].type == 8 || result.list[i].type == 9){
                            if(!this.endTime){
                                resultArray2.push(result.list[i])
                            }
                        }else {
                            if(result.list[i].packageName.includes('200')){
                                resultArray1.push(result.list[i])
                            }else {
                                resultArray1.unshift(result.list[i])
                            }
                        }
                    }
                }
                 /**每月倒数第6天默认选中次月生效**/
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth();
                var day = date.getDate();
                console.log('当前日期'+day);
                console.log('当前cucc'+this.thisCucc);
                var date2 = new Date(year, month + 1, 0)
                var endDay = date2.getDate();
                if(this.thisCucc==0){
                    day >= endDay - 8 ? this.isNextMonth = '1' : this.isNextMonth = '0';
                }else{
                    if(day >=21 && day <=26){
                        this.isNextMonth ='1'
                    }else{
                        this.isNextMonth= '0'
                    }
                }
                this.simData = resultArray1.concat(resultArray2);
                this.simData.sort((a,b) => b.sort - a.sort);
                this.isAdmin = result.isAdmin;
                this.globalIsAdmin = result.isAdmin;
                this.isNaturalMonth = this.simData[0].type == 2 || this.simData[0].type == 10 || this.simData[0].type == 14|| this.simData[0].type == 6
                || this.simData[0].type == 25 || this.simData[0].type == 17? true : false; 
                this.isShowdetail=  this.simData[0].type == 2 ||  this.simData[0].type == 10? true : false; 
                this.indexActive = this.simData[0].id;
                this.price = this.simData[0].salePriceRmb;
                this.itemInfo = this.simData[0];
                this.limitState = this.simData[0].limitState
                this.toatl = 0
                this.secondaryId = ''
                this.primaryId = ''
                if (this.$route.query.total) {
                    this.toatl = this.$route.query.total * 1 || 0
                    this.secondaryId = this.$route.query.secondaryId
                    this.primaryId = this.$route.query.primaryId
                }else{
                    this.toatl = result.subJuan.price * 1 || 0
                    if(result.subJuan.types === 1){
                        this.secondaryId = result.subJuan.id
                    }else{
                        this.primaryId = result.subJuan.id
                    }
                }
                
            }
        })

       
    }
}
</script>
<style lang="less" scoped>

#rechargeB {
    background: #F6F6F6;
	height: calc(100% - 104px);
	overflow: auto;
	position: relative;
    .header {
		color: #fff;
		height:232px;
		display: flex;
		position: relative;
		padding:20px;
        background-image: linear-gradient(#F23E3D,#fff);
		// background-image: linear-gradient(#1946C4,#F6F6F6,#F6F6F6);
		.logo{
			width: 52px;
			height: 52px;
			margin-right: 10px;
			img{
				width: 52px;
				height: 52px;
				margin-bottom: 10px;
				border-radius: 35px;
				border: 2px solid #fff;
			}
		}
		.header-userInfo{
			padding-top: 8px;
			.iccid-line{
				display: inline-block;
				font-size:1.125rem;
				margin-bottom: 5px;
			}
			.el-status{
				font-size:0.75rem;
			}
		}
    } 

    
    .packagePanel {
		width:95%;
		margin:0 auto;
		background: #fff;
		position: absolute;
		top:16%;
		left: 0;
		right:0;
		border-radius:0.625rem;
        .tabbar{
            display: flex;
            height: 60px;
            margin-bottom: 10px;
            p {
                flex: 1;
                height: inherit;
                text-align: center;
				font-size:1.125rem;
				line-height:60px;
				background: #F2F3F8;
				color: #94959A;
				font-weight:600;
            }
			p:first-child{
				border-top-left-radius: 10px;
			}
			p:nth-child(2){
				border-top-right-radius: 10px;
			}
            .activeTab {
				line-height:60px;
				display: inline-block;
				color:#000000;
				background:#fff;
				height: 100%;
				display: inline-block;
				width: 100%;
            }
        }
        .package-title{
            padding: 10px 0px;
            color: #333;
            font-weight:bold;
        }

        .package{
            // flex:1;
			padding: 10px 5px;
            position: relative;
			// height:10rem;
            .label-defined{
                display: block;
                border-width: 14px 18px 14px 18px;
                border-style: solid;
                border-color: transparent;
                position: absolute;  

                label{
                    position: absolute;
                    left: -14px;
                    top: -12px;
                    background: transparent;
                } 
            }
            .package-name{
                flex-grow: 1;
                padding: 5px 10px;
                background: #fff;
				border-radius:10px;
                position: relative;
				border: #EEEDED 1px solid;
                display: flex;
               .price-title{
                    width:80%;
                    text-align: left;
                    padding-left:10px;
                    p{
                        color:#999999;
                        font-size:14px;
                    }
                }
                .titleRemark{
                    position: absolute;
                    top:-5px;
                    line-height:30px;
                    color:#fff;
                    left:0;
                    height:30px;
                    padding: 0 10px;
                    background:red;
                    border-radius: 10px 0 10px  0;
                }
                h1{
                    margin:14px 0;
                    color: #000;
					// height:40px;
                    font-size:1rem;
					font-weight:600;
					line-height:20px;
                }
                p{
                    margin: 10px 0;
                    color: #333;
                    line-height: 20px;
                    font-size: 14px;
                    font-weight: bold;
                }
                .dialog{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left:0;
                    top:0;
                    background: rgba(0,0,0,.3);
                    border-radius: 10px;
                    display: flex;
                    justify-items: center;
                    align-items: center;
                    .deblocking{
                        width: 121px;
                        height: 38px;
                        background: linear-gradient(90deg, #FFA451 0%, #FF6463 100%);
                        border-radius: 19px;
                        font-size:14px;
                        color:#fff;
                        text-align: center;
                        line-height:38px;
                        margin:0 auto;
                    }
                    .deblocking1{
                        background: #ccc !important;
                        color:#000 !important;
                    }
                }
            }
			.label-defined-active{
			    background:#FFF3EC url(../../assets/home/icon44.png) no-repeat right bottom;
				background-size:35px 30px;
				border: #FF6463 1px solid;
			}

            p.package-price{
                flex-grow: 0;
                display: flex;
                flex-direction: column;
                // justify-content: center;
                // align-items: center;
				color: #FF6463;
				font-weight: 600;
				font-size: 1rem;
            }

            .package-price.overlay-package{
                border-color: #07c160;
                background: #07c160;
            }
            
        }

    }

    .quan {
        background: #F6F6F6;
        display: flex;
        align-items: center;
        height: 52px;
        margin-top:4px;
        div {
            width: 50%;
        }

        .w-zh {
            color: #28292D;
            font-size: 18px;
            padding-left: 20px;
            line-height:52px;
            font-weight: 600;
            height: 100%;
        }

        .z-icon {
            text-align: right;
            background: url('../../assets/hd/arrow.png')no-repeat 90% center;
            padding-right: 36px;
            color: #DE4160;
            font-weight: 600;
            font-size: 14px;
            height: 100%;
            line-height:52px;
        }
    }

    .toRecharge{
        position: fixed;
        width: 100%;
        bottom: 0;
        font-size: 16px;
		background: #fff;
        .toRecharge-top{
            display: flex;
            .radio-group-defined{
                display: flex;
                padding-left: 20px;
                justify-content: center;
                align-items: center;
				border-bottom: 1px solid #eee;
                height: 34px;
				/deep/.van-radio__icon--checked{
					.van-icon-success{
						background-color: #24BAC8 !important;
						border-color: #24BAC8 !important;
					}
				}
				/deep/.van-radio__label{
					color:#666;
					margin-left:0px
				}
                div{
                    height: 20px;
                    margin-right: 15px;
					.van-icon{
						font-size:12px;
					}
					&.van-radio__icon {
						margin-right: 0;
					}
                }
				span{
					font-size:0.75rem;
				}
            }

        }

        .detail {
            color: #96989D;
			font-size: 12px;
            padding-left: 20px;
            padding-top: 5px;
        }

        .toRecharge-bottom{
            display: flex;
			line-height:46px;
            p{
                padding-right: 15px;
                flex-grow: 1;
                color: #999;
                background:#fff;
				font-size: 0.75rem;
                text-align: left;
				line-height:46px;
				padding-left:10px;
                span{
                    color:#FF6463;
					font-weight: 600;
					font-size:1rem;
					vertical-align: middle;
                }
            }

            .toRechargeBtn{
                padding: 0 60px;
                display: inline-block;
                line-height: 46px;
                flex-grow: 0;
                color: #fff;
                background: #FF6463;
            }
            .toRechargeBtn1{
                color:#000;
                background: #ccc;
            }
        }

    }
}
.van-dialog{
    background:url('../../assets/home/iconBg.png') no-repeat center;
    width:290px;
    height:247px;
    background-size: 100%;
    ::v-deep .van-dialog__header{
        margin-top:70px;
        color: #222;
        font-weight: 600;
        font-size:19px;
    }
    .dialog-text{
        color: #94959A;
        font-size:15px;
        padding-top:11px;
        text-align: center;
        padding-bottom:34px;
    }
    .btn-vis {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width:90%;
        margin: auto;
        .dialog-btn2 {
            width: 120px;
            height: 47px;
            color: #666666;
            text-align: center;
            background: #F5F5F5 !important;
            border: 0 !important;
            border-radius: 7px;
            font-size: 16px;
            line-height: 47px;
        }
        .dialog-btn3 {
            width: 130px;
            height: 47px;
            border-radius: 7px;
            font-size: 16px;
            line-height: 47px;
            border: 0;
            color: #fff;
            background: linear-gradient(90deg, #FFA451 0%, #FF6140 100%);
            margin-left: 10px;
            text-align: center;
        }
    }
}
</style>
